export default "__VITE_ASSET__8c77490a__"